import httpClient from '../httpClient';

const revealContact = listingId => {
  return httpClient.get(`listings/${listingId}/reveal-contact`);
};

const inquireListing = (listingId, body) => {
  return httpClient.post(`listings/${listingId}/inquire`, body);
};

const incrementListingStatistics = (listingId, body) => {
  return httpClient.post(`listings/${listingId}/statistics`, body);
};

const publish = listingId => {
  return httpClient.post(`listings/${listingId}/publish`);
};

export default {
  incrementListingStatistics,
  inquireListing,
  publish,
  revealContact,
};
